export default (value) => {
  if (!value || value.length <= 0) return 0;
  return value
    .toString()
    .replace(/(<([^>]+)>)/gi, '')
    .replace(/[-]+/g, '')
    .match(/[\u00ff-\uffff]|\S+/g).length;
};
